import { apiFetch } from "../utils/apiFetch"

export function createGoodsAndServices(entries: any[]) {
  return apiFetch("/api/goods-and-services", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ entries })
  })
}

export function updateGoodsAndServices(id: string, entries: any[]) {
  return apiFetch(`/api/goods-and-services/${id}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ entries })
  })
}

export function deleteGoodsAndServices(id: string) {
  return apiFetch(`/api/goods-and-services/${id}`, { method: "DELETE" })
}
